<template>
  <div class="container">
    <div class="weui-navbar daojia-navbar">
        <div class="daojia-navbar-left" @click="close()"><span class="icon-chevron-left"></span></div>
        <h1 class="daojia-navbar-middle daojia-navbar-middle_logo"><a href="#"><img src="../../assets/img/global/logo.png"></a></h1>
        <div class="daojia-navbar-right">
        </div>
    </div>
    <div class="image-box">
        <img v-if="type=='1550735948'" src='/static/img/services/clean-price/dasaochu_01.gif'>
        <img v-if="type=='1550735948'" src='/static/img/services/clean-price/dasaochu_02.gif'>
        <img v-if="type=='1550735948'" src='/static/img/services/clean-price/dasaochu_03.gif'>
        <img v-if="type=='1550735961'" src='/static/img/services/clean-price/duanzuwu_01.gif'>
        <img v-if="type=='1550735961'" src='/static/img/services/clean-price/duanzuwu_02.gif'>
        <img v-if="type=='1550735961'" src='/static/img/services/clean-price/duanzuwu_03.gif'>
        <img v-if="type=='1550735971'" src='/static/img/services/clean-price/zhouqi_01.gif'>
        <img v-if="type=='1550735971'" src='/static/img/services/clean-price/zhouqi_02.gif'>
        <img v-if="type=='1550735971'" src='/static/img/services/clean-price/zhouqi_03.gif'>
        <img v-if="type=='1550735962'" src='/static/img/services/clean-price/zhuanxiang.gif'>
    </div>
    <div class="btn-box-fix" v-show="!$route.query.back">
      <div class="btn-container">
		      <div class="btn active" @click="close()" >返回</div>
      </div>
    </div>
    <img :src="pixelURL('qingjie','baojia')" class="hide">
  </div>
</template>

<script>

export default {
  name: 'datepicker-fullpage',
  data () {
    return {
    }
  },
  props: ['type'],
  methods: {
    close: function () {
      this.$emit('close')
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.navi{
    display: flex;
    justify-content:space-between;
    padding:0 0 0 0;
    width:100%;
    background:rgba(255, 255, 255, 0.94);
    span{
        flex: 1;
    }
    div{
        flex:2;
    }
    .close{
        text-align:left;
        font-size:1em;
        .icon-arrow-left{
            margin-right:12px;
            margin-top:12px;
            display:inline-block;
        }
    }
}
.icon-arrow-left{
    padding-left:12pt;
}
.container{
  padding-top:40px;
}

.title{
  font-size:1.4em;
}
.empty{
  padding:0 20vw;
  text-align:center;
  margin-top:2vh;
  width:100vw;
  box-sizing:border-box;
  color:#999;
  a{
    color:#fe9567;
  }
}
.image-box{
  img{
    width:100%;
  }
  font-size:0;
}
.btn{
  margin-top:20px;
}
.text{
  text-align:center;
  font-size:1.2em;
  color:#888;
}

.daojia-navbar {
    position: fixed;
    background: rgba(255, 255, 255, 0.95);
    padding: 8px 10px;
    box-sizing: border-box;
    height: 50px;
}

.daojia-navbar-left {
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: left;
    span{
      font-size: 2em;
      color: #666;
    }
}

.daojia-navbar-middle_logo img{
    height:34px;
}

.daojia-navbar-middle {
    display: block;
    -webkit-box-flex: 2;
    -webkit-flex: 2;
    flex: 2;
    font-smoothing: antialiased;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    font-family: sans-serif;
    font-size: 1.2em;
    line-height: 1.3;
    font-weight: bold;
}

.daojia-navbar-right {
    font-size: 14px;
    line-height: 26px;
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: right;
}

.btn-box-fix .btn.active{
  margin-left:0;
}

</style>



// WEBPACK FOOTER //
// src/components/cleanprice/index.vue